import {
  AMMobilityPolygonAllRankRequest,
  AMMobilityPolygonAllRankResponse,
  AMMobilityPolygonTopLocation,
  AMMobilityPolygonTopLocationsMatthewsRequest,
  AMMobilityPolygonTopLocationsRequest,
  BuildoutTradeAreaDetailsRequest,
  DriveTimeSectionDetails,
  DriveTimeTradeAreaDetailsResponse,
  MatthewsTenantMatchRequest,
  RadiusRingsTradeAreaDetailsResponse,
} from 'src/common-services'
import { BaseClient } from 'src/common-services/clients/base-client'
import { UpdateBuildoutConfigRequest } from 'src/common-services/types/partners-type'
import { RankedLocation } from 'src/types'

export class PartnersClient extends BaseClient {
  updateBuildoutConfig(request: UpdateBuildoutConfigRequest): Promise<RankedLocation[]> {
    return this.call<RankedLocation[]>(`/partners/buildout/config/${request.configId}`, 'PUT', {
      data: request.config,
    })
  }

  getBuildoutDriveTimeTradeAreaDetails(
    request: BuildoutTradeAreaDetailsRequest
  ): Promise<DriveTimeTradeAreaDetailsResponse> {
    return this.call('/partners/buildout/trade-area/by-drive-time', 'GET', {
      params: { token: request.token, override: request.override },
    })
  }

  getBuildoutDriveTimeTradeAreaMap(request: BuildoutTradeAreaDetailsRequest): Promise<DriveTimeSectionDetails[]> {
    return this.call('/partners/buildout/trade-area/by-drive-time/map', 'GET', {
      params: { token: request.token, override: request.override },
    })
  }

  getBuildoutRadiiTradeAreaDetails(
    request: BuildoutTradeAreaDetailsRequest
  ): Promise<RadiusRingsTradeAreaDetailsResponse> {
    return this.call('/partners/buildout/trade-area/by-radius-rings', 'GET', {
      params: { token: request.token, override: request.override },
    })
  }

  getMatthewsLocationsInArea(
    request: AMMobilityPolygonTopLocationsRequest
  ): Promise<{ locations: AMMobilityPolygonTopLocation[]; totalLocations: number }> {
    return this.call<{ locations: AMMobilityPolygonTopLocation[]; totalLocations: number }>(
      '/partners/matthews/polygon-locations',
      'POST',
      {
        data: request,
      }
    )
  }

  getMatthewsTopLocationsInArea(
    request: AMMobilityPolygonTopLocationsMatthewsRequest
  ): Promise<AMMobilityPolygonTopLocation[]> {
    return this.call<AMMobilityPolygonTopLocation[]>('/partners/matthews/top-locations', 'POST', {
      data: request,
    })
  }

  getMatthewsLocationRanks(request: AMMobilityPolygonAllRankRequest): Promise<AMMobilityPolygonAllRankResponse[]> {
    return this.call<AMMobilityPolygonAllRankResponse[]>('/partners/matthews/all-rank', 'POST', {
      data: request,
    })
  }

  getMatthewsMatchedTenantLocationId(request: MatthewsTenantMatchRequest): Promise<{ id: string }> {
    return this.call<{ id: string }>('/partners/matthews/match-tenant-location', 'GET', {
      params: { lat: request.lat, lng: request.lng, name: request.name },
    })
  }
}
